module.exports = __webpack_public_path__ + "images/category_lp/bike/assessment_achievements/1_9909e6f294b35ba2f4055f952a4b5d79.jpg";